import styled from 'styled-components';

export const MainPage = styled.main`
  display: flex;
  flex-direction: column;
  color: white;

  padding-bottom: 20%;
`;
